module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/alignright.1b2574e4.svg";